/*
 * @Author: CaoJianBo
 * @Date: 2023-07-10 10:46:42
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2024-08-06 14:47:57
 * @FilePath: \fe-crm\src\router\sub\product.js
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const PRODUCT = {
  path: '/product',
  name: 'product',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'product-list' },
  meta: {
    title: '产品',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'product',
    order: 5
  },
  children: [
    {
      path: 'index',
      name: 'product-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'product-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'product:view',
        title: '产品管理'
      },
      children: [
        {
          path: '',
          name: 'product-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 4 },
          meta: {
            requiresAuth: true,
            roles: 'product:view',
            title: '产品管理'
          }
        },
        {
          path: ':id/collaborators',
          name: 'product-index-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 4 },
          meta: {
            requiresAuth: true,
            roles: 'product:view',
            title: '产品管理详情'
          }
        },
        {
          path: ':id',
          name: 'product-index-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 4 },
          meta: {
            requiresAuth: true,
            roles: 'product:view',
            title: '产品管理详情'
          }
        }
      ]
    }
  ]
};

export default PRODUCT;
